var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFilterMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72.482,
    height: 57.986,
    viewBox: "0 0 72.482 57.986",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_684",
    "data-name": "Path 684",
    d: "M49.092,18.793,60.553,6.124A3.587,3.587,0,0,0,58.017,0H3.6A3.587,3.587,0,0,0,1.059,6.124L21.746,28.993V46.651a4.532,4.532,0,0,0,1.812,3.624l9.059,6.8a4.509,4.509,0,0,0,6.707-1.537,21.694,21.694,0,0,1,9.768-36.741Zm5.271,2.951A18.121,18.121,0,1,0,72.484,39.865,18.12,18.12,0,0,0,54.363,21.745Zm1.812,27.167v1.826a.906.906,0,0,1-.906.906H53.457a.906.906,0,0,1-.906-.906V48.893A6.485,6.485,0,0,1,49,47.607a.907.907,0,0,1-.065-1.375l1.331-1.27a.93.93,0,0,1,1.147-.083,2.727,2.727,0,0,0,1.452.421h3.184a1.424,1.424,0,0,0,1.336-1.494,1.478,1.478,0,0,0-.993-1.442l-5.1-1.529a5.125,5.125,0,0,1-3.577-4.914,5.043,5.043,0,0,1,4.833-5.1V28.993a.906.906,0,0,1,.906-.906h1.812a.906.906,0,0,1,.906.906v1.845a6.476,6.476,0,0,1,3.553,1.285.907.907,0,0,1,.065,1.375l-1.331,1.27a.93.93,0,0,1-1.147.083,2.717,2.717,0,0,0-1.452-.421H52.678a1.424,1.424,0,0,0-1.336,1.494,1.478,1.478,0,0,0,.993,1.442l5.1,1.529a5.125,5.125,0,0,1,3.577,4.914,5.042,5.042,0,0,1-4.833,5.1Z",
    transform: "translate(-0.001)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilterMoney);
export default __webpack_public_path__ + "static/media/icon-filter-money.8a2f35be32dd5c0d7a39a855b7024729.svg";
export { ForwardRef as ReactComponent };